import React from 'react';
import { useSelector } from 'react-redux';

export default function useSalesSelector() {
  const SalesListData = useSelector((state) => state?.sales?.list_data?.payouts) || [];

  return { SalesListData };
}
